import { styled } from 'parkdepot-shared/theme'

export const VehiclesContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: '3.2rem'
}))

export const VehicleErrorContainer = styled('div', ({ $theme }) => ({
    color: 'red',
    marginBottom: '0.8rem',
    fontSize: '1.2rem'
}))

export const TrashIcon = styled('i', ({ $theme }) => ({
    cursor: 'pointer',
    color: $theme.colors.primary,
    fontSize: '1.6rem'
}))

export const VehicleContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}))

export const SecondVehicleContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '3.2rem'
}))

export const AddIcon = styled('i', ({ $theme }) => ({
    fontSize: '1.6rem',
    cursor: 'pointer'
}))
